import React from 'react';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';

const Paragraph = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
    color: '#707070',
    [theme.breakpoints.up('sm')]: {
      marginTop: 20,
    },
  },
}))(Typography);

interface Props {
  value: string;
  className: string;
}

const Introduction = ({ value, className }: Props) => (
  <Paragraph
    display="block"
    variant="body2"
    color="textPrimary"
    className={`${className} text-break-all`}
  >
    {value}
  </Paragraph>
);

export default Introduction;
